/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BlogDetailInfo } from '../models/BlogDetailInfo';
import type { ContentHomeSummaryInfo } from '../models/ContentHomeSummaryInfo';
import type { ContentListInfo } from '../models/ContentListInfo';
import type { EventContentListInfo } from '../models/EventContentListInfo';
import type { EventDisclosureDetailInfo } from '../models/EventDisclosureDetailInfo';
import type { EventIntelligenceDetailInfo } from '../models/EventIntelligenceDetailInfo';
import type { NoticeDetailInfo } from '../models/NoticeDetailInfo';
import type { ResearchDetailInfo } from '../models/ResearchDetailInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ContentControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns ResearchDetailInfo OK
     * @throws ApiError
     */
    public getResearchDetail({
        docId,
    }: {
        docId: string,
    }): CancelablePromise<ResearchDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/content/research',
            query: {
                'docId': docId,
            },
        });
    }

    /**
     * @returns NoticeDetailInfo OK
     * @throws ApiError
     */
    public getNoticeDetail({
        docId,
    }: {
        docId: string,
    }): CancelablePromise<NoticeDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/content/notice',
            query: {
                'docId': docId,
            },
        });
    }

    /**
     * @returns ContentListInfo OK
     * @throws ApiError
     */
    public getContentList({
        contentType,
        page = 1,
        size = 10,
        orderBy = 'LATEST',
    }: {
        contentType: 'RESEARCH' | 'NOTICE' | 'EVENT' | 'BLOG',
        page?: number,
        size?: number,
        orderBy?: 'LATEST' | 'OLDEST' | 'TRENDING' | 'VIEWS',
    }): CancelablePromise<ContentListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/content/list',
            query: {
                'contentType': contentType,
                'page': page,
                'size': size,
                'orderBy': orderBy,
            },
        });
    }

    /**
     * @returns ContentHomeSummaryInfo OK
     * @throws ApiError
     */
    public getContentHome(): CancelablePromise<Array<ContentHomeSummaryInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/content/home/list',
        });
    }

    /**
     * @returns EventContentListInfo OK
     * @throws ApiError
     */
    public getEventList({
        page = 1,
        size = 10,
        orderBy = 'LATEST',
    }: {
        page?: number,
        size?: number,
        orderBy?: 'LATEST' | 'OLDEST' | 'TRENDING' | 'VIEWS',
    }): CancelablePromise<EventContentListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/content/event/list',
            query: {
                'page': page,
                'size': size,
                'orderBy': orderBy,
            },
        });
    }

    /**
     * @returns EventIntelligenceDetailInfo OK
     * @throws ApiError
     */
    public getIntelligenceDetail({
        id,
    }: {
        id: string,
    }): CancelablePromise<EventIntelligenceDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/content/event/intelligence',
            query: {
                'id': id,
            },
        });
    }

    /**
     * @returns EventDisclosureDetailInfo OK
     * @throws ApiError
     */
    public getDisclosureDetail({
        id,
    }: {
        id: string,
    }): CancelablePromise<EventDisclosureDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/content/event/disclosure',
            query: {
                'id': id,
            },
        });
    }

    /**
     * @returns EventContentListInfo OK
     * @throws ApiError
     */
    public getComingEventList({
        page = 1,
        size = 5,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<EventContentListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/content/event/coming/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BlogDetailInfo OK
     * @throws ApiError
     */
    public getBlogDetail({
        docId,
    }: {
        docId: string,
    }): CancelablePromise<BlogDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/content/blog',
            query: {
                'docId': docId,
            },
        });
    }

}
